import ToastStatusGlobal from '@/components/toastStatusGlobal';
import { MOVE_STATUS_TRANSLATED } from '@/modules/move/entities/constants/move';
import { MOVE_STATUS } from '@/modules/move/entities/enums/move';
import { MoveNormalized, MoveStatusDialogConfirm } from '@/modules/move/entities/interfaces/move';
import useConfirm from '@/shared/hooks/useConfirm';
import { useRef, useState } from 'react';
import { MoveService } from '@/modules/move/services';

interface UseMoveStatusArgs {
  move?: MoveNormalized;
  onChangeStatusCallback?: (status: MOVE_STATUS) => void;
}

const moveService = new MoveService();

const useMoveStatus = ({ move, onChangeStatusCallback }: UseMoveStatusArgs) => {
  const { toast } = ToastStatusGlobal();
  const { confirm, dialogConfirm } = useConfirm();
  const [openDialogConfirmUpdateStatusForm, setOpenDialogConfirmUpdateStatusForm] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const fnCallback = useRef<((response: MoveStatusDialogConfirm) => void) | undefined>(undefined);

  const confirmUpdateStatusMoveAndGetReason = async (status: string) => {
    let confirmUpdate: boolean | null = true;
    let reason = '';

    if (status === MOVE_STATUS.PROCESSED) {
      confirmUpdate = await confirm(
        'Atenção',
        `Ao alterar o status para <b>Processado</b> você não
            poderá alterá-lo novamente. Quer mesmo fazer isso?`,
      );
    }

    if (status === MOVE_STATUS.REJECTED) {
      await new Promise((resolve) => {
        fnCallback.current = (response: MoveStatusDialogConfirm): void => {
          setOpenDialogConfirmUpdateStatusForm(false);
          confirmUpdate = response.confirm;
          reason = response.reason;
          resolve(response);
        };

        setOpenDialogConfirmUpdateStatusForm(true);
      });
    }

    return {
      confirmUpdate,
      reason,
    };
  };

  const onChangeStatus = async (status: MOVE_STATUS) => {
    if (move && move.id && MOVE_STATUS_TRANSLATED[status] !== move.status) {
      setLoadingStatus(true);

      try {
        const { confirmUpdate, reason } = await confirmUpdateStatusMoveAndGetReason(status);

        if (confirmUpdate) {
          await moveService.updateStatus(move.id, { status, rejectionReason: reason });
          toast('Feito!', 'Status do arquivo alterado com sucesso!', 'success');
          onChangeStatusCallback?.(status);
        }
      } catch (e) {
        toast('Oops!', 'Não foi possível alterar o status do arquivo.', 'error');
        console.error('error', e);
      } finally {
        setLoadingStatus(false);
      }
    }
  };

  return {
    onChangeStatus,
    dialogConfirm,
    openDialogConfirmUpdateStatusForm,
    callbackDialogConfirmUpdateStatusForm: fnCallback.current,
    loadingStatus,
  };
};

export default useMoveStatus;
